import { Menu as InnerMenu, MenuItem, SubMenu } from './menu';
const Menu = InnerMenu;
Menu.Item = MenuItem;
Menu.SubMenu = SubMenu;
export default Menu;
